<!-- @format -->
@if (review()) {
	@if (hasRequiredValuesToSEO()) {
		<!-- SEO Review -->
		<div
			class="review-card hmf-fulfillment-options-container hmf-justify-content-left hmf-sharp-radius hmf-p-s hmf-p-m"
			itemprop="review"
			itemscope
			itemtype="https://schema.org/Review">
			<!-- SEO Author -->

			<div
				class="review-card-header hmf-display-flex hmf-justify-content-between hmf-align-items-center hmf-mb-xxs">
				<p
					class="hmf-text-transform-capitalize hmf-m-0 user-nickname-wrapper"
					itemprop="author"
					itemscope
					itemtype="https://schema.org/Person">
					<span
						class="hmf-m-0 user-nickname"
						itemprop="name"
						>{{ review().UserNickname }}</span
					>
				</p>

				@if (review().BadgesOrder && (review().BadgesOrder[0] === 'verifiedPurchaser' || review().BadgesOrder[1] === 'verifiedPurchaser')) {
					<product-reviews-review-badges
						[badgeType]="review().BadgesOrder[0]"></product-reviews-review-badges>
				}
			</div>

			<!-- SEO Product -->
			<div
				itemprop="itemReviewed"
				itemscope
				itemtype="https://schema.org/IndividualProduct">
				<meta
					itemprop="name"
					content="{{ product().name }}" />
			</div>

			<div
				class="hmf-display-flex hmf-align-items-center hmf-align-self-start hmf-justify-content-between hmf-mb-xxs hmf-mt-0">
				<product-reviews-review-stars
					class="hmf-display-inline-flex"
					[options]="starsOptions()"
					[rating]="review().Rating"></product-reviews-review-stars>

				<!-- SEO Rating -->
				<div
					itemprop="reviewRating"
					itemscope
					itemtype="https://schema.org/Rating">
					<meta
						itemprop="ratingValue"
						content="{{ review().Rating }}" />
					<meta
						itemprop="bestRating"
						content="{{ review().RatingRange }}" />
					<meta
						itemprop="worstRating"
						content="1" />
				</div>

				<!-- SEO Created/Published -->
				<meta
					itemprop="dateCreated"
					content="{{ review().SubmissionTime | date: 'yyyy-MM-dd' }}" />
				<!-- Submission type is in a meta because we don't want the date transformed by dateAgo Pipe below -->
				<meta
					itemprop="datePublished"
					content="{{ review().LastModeratedTime | date: 'yyyy-MM-dd' }}" />

				<div class="user-info-badge hmf-header-xxs hmf-ml-xxs">
					{{ review().SubmissionTime | dateAgo }}
				</div>
			</div>
			<h2
				class="hmf-header-bold-xs hmf-text-transform-capitalize hmf-mb-xxs hmf-mt-0"
				itemprop="headline">
				{{ review().Title | titlecase }}
			</h2>

			<!-- SEO Review Body -->
			<p
				class="review-text"
				itemprop="reviewBody">
				{{ review().ReviewText }}
			</p>

			<button
				hmf-action-text
				variant="secondary"
				(click)="openDrawer(review().CID)"
				(keydown.enter)="openDrawer(review().CID)"
			>
				Read More
			</button>
		</div>
	} @else {
		<div
			class="review-card hmf-fulfillment-options-container hmf-justify-content-left hmf-sharp-radius hmf-p-s hmf-p-m">
			<div
				class="review-card-header hmf-display-flex hmf-justify-content-between hmf-align-items-center hmf-mb-xxs">
				<p class="hmf-text-transform-capitalize hmf-m-0 user-nickname-wrapper">
					<span class="hmf-m-0 user-nickname">{{ review().UserNickname }}</span>
				</p>

				@if (review().BadgesOrder && (review().BadgesOrder[0] === 'verifiedPurchaser' || review().BadgesOrder[1] === 'verifiedPurchaser')) {
					<product-reviews-review-badges
						[badgeType]="review().BadgesOrder[0]"></product-reviews-review-badges>
				}
			</div>

			<div
				class="hmf-display-flex hmf-align-items-center hmf-align-self-start hmf-justify-content-between hmf-mb-xxs hmf-mt-0">
				<product-reviews-review-stars
					class="hmf-display-inline-flex"
					[options]="starsOptions()"
					[rating]="review().Rating"></product-reviews-review-stars>

				<div class="user-info-badge hmf-header-xxs hmf-ml-xxs">
					{{ review().SubmissionTime | dateAgo }}
				</div>
			</div>
			<h2 class="hmf-header-bold-xs hmf-text-transform-capitalize hmf-mb-xxs hmf-mt-0">
				{{ review().Title | titlecase }}
			</h2>

			<p class="review-text">
				{{ review().ReviewText }}
			</p>

			<button
				hmf-action-text
				variant="secondary"
				(click)="openDrawer(review().CID)"
				(keydown.enter)="openDrawer(review().CID)">
				Read More
			</button>
		</div>
	}
}
